import { useEffect, useState } from "react";

export type Choice = readonly [value: string, label: string];

export function ChoiceControl({ label, value, choices, onChange }: { label: string; value: string; choices: readonly Choice[]; onChange(value: string): void }) {
  return <label className="control"><span>{label}</span><select value={value} onChange={event => onChange(event.target.value)}>{choices.map(([key, title]) => <option value={key} key={key}>{title}</option>)}</select></label>;
}

export function ToggleControl({ label, checked, onChange }: { label: string; checked: boolean; onChange(value: boolean): void }) {
  return <label className="customization-toggle"><span>{label}</span><input type="checkbox" checked={checked} onChange={event => onChange(event.target.checked)}/></label>;
}

export function ColourControl({ label, value, onChange }: { label: string; value: string; onChange(value: string): void }) {
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [value]);
  const valid = /^#[0-9a-f]{6}$/i.test(draft);
  return <label className="customization-colour"><span>{label}</span><div><input type="color" aria-label={label} value={value} onChange={event => onChange(event.target.value)}/><input aria-label={`${label} HEX`} maxLength={7} value={draft} aria-invalid={!valid} onChange={event => { setDraft(event.target.value); if (/^#[0-9a-f]{6}$/i.test(event.target.value)) onChange(event.target.value.toUpperCase()); }} onBlur={() => { if (!valid) setDraft(value); }}/></div></label>;
}
